import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Icon } from '@modulor/react';
import withAnalytics from '../../../hocs/withAnalytics';
import useIsDesktopLayout from '../../../hooks/useIsDesktopLayout';
import styles from './NavigationItem.module.css';

export const NavLinkWithAnalytics = withAnalytics(NavLink);

export function NavigationItem({
  icon,
  children,
  to,
  count,
  dataLayerEventData,
  ...props
}) {
  const isDesktop = useIsDesktopLayout();

  return (
    <NavLinkWithAnalytics
      exact
      to={to}
      className={(isActive) =>
        classNames(styles['NavigationItem'], isActive && styles.active)
      }
      dataLayerEventData={dataLayerEventData}
      {...props}
    >
      <div className={styles['icon']}>{icon}</div>
      <div className={styles['text']}>
        {children}
        {count && <div className={styles['count']}>{count}</div>}
        {!isDesktop && (
          <Icon name="chevron_right" size={24} className={styles['arrow']} />
        )}
      </div>
    </NavLinkWithAnalytics>
  );
}

NavigationItem.propTypes = {
  icon: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  count: PropTypes.number,
};

export default NavigationItem;
